import { Col, Collapse, message, notification, Row, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  dineroDisabledMask,
  ModalItem,
} from "../../../../Components/Items";
import moment from "moment";
import PagoConekta from "./PagoConekta/PagoConekta";
import DomicializacionConekta from "./DomicializacionConekta/DomicializacionConekta";
import CorreoEmpresa from "./CorreoEmpresa/CorreoEmpresa";
import { Alert } from "antd5";
import {
  WalletOutlined,
  CheckCircleFilled,
  UserOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import "../../../../Components/Styles.css";

const { Panel } = Collapse

function capitalizar(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

class PagarEmpresa extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    fechaVencimiento: null,
    usuarios: 0,
    contadores: 0,
    montoMensualFinalConIVA: 0,
    montoAnualFinalConIVA: 0,
    tipoPagoString: 0,
    pagosHtml: null,
    abrirPagoConekta: false,
    abrirDomicializacion: false,
    abrirCorreo: false,
    empresasActualizarTambien: [],
    empresaActualizar: null,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarTodo();
    }
  }

  checarPago(orderId) {
    axios.post('facturacion/checarPago', { orderId })
      .then((res) => {
        if (res.data.success === 2) {
          if (window.registrarMovimiento) {
            window.registrarMovimiento({
              titulo: 'Pago Verificado',
              mensaje: 'Se ha verificado el pago',
              icono: 7,
            });
          }
        } else if (res.data.success === 1) {
          notification.info({
            message: res.data.message ? res.data.message : "El pago ya fue verificado anteriormente",
            duration: 2.0,
          });
        } else {
          notification.error({
            message: res.data.err,
          });
        }
        this.consultarTodo()
      }).catch(err => {
        notification.error({
          message: "Error no se pudo verificar el pago",
        });
      })
  }

  cancelarDomicializacion(domId) {
    axios.post('domicializacion/cancelarDomicializacion', { domId })
      .then((res) => {
        if (res.data.success === 2) {
          if (window.registrarMovimiento) {
            window.registrarMovimiento({
              titulo: 'Domiciliación Cancelada',
              mensaje: 'Se ha cancelado la domiciliación',
              icono: 7,
            });
          }
        } else {
          notification.error({
            message: res.data.err,
          });
        }
        this.consultarTodo()
      }).catch(err => {
        notification.error({
          message: "Error no se pudo cancelar la domicialización",
           duration: 2.0,
        });
      })
  }


  cerrarPagarEmpresa(codigo) {
    this.props.cerrarPagarEmpresa(codigo);
    this.setState({
      loading: false,
      fechaVencimiento: null,
      usuarios: 0,
      contadores: 0,
      montoMensualFinalConIVA: 0,
      montoAnualFinalConIVA: 0,
      tipoPagoString: 0,
      pagosHtml: null,
      abrirPagoConekta: false,
      abrirDomicializacion: false
    })
  }
  async consultarTodo() {
    this.setState({ loading: true });

    await axios.post('facturacion/selectPagos', { empresaId: this.props.id })
      .then(res => {
        if (res.data.success === 2) {
          let nuevoObjeto = []
          if (res.data.domicializacionVigente) {
            nuevoObjeto = [{
              ...res.data.domicializacionVigente,
              domicializacion: true,
            }]
          }

          nuevoObjeto = nuevoObjeto.concat(res.data.pagos)

          const html = (
            <Collapse style={{ marginBottom: 10 }}>
              {nuevoObjeto.map((valuePago) => {

                if (valuePago.domicializacion) {

                  let nombreTarjeta = ''

                  if (valuePago.cardBrand) {
                    nombreTarjeta += capitalizar(valuePago.cardBrand)
                  }


                  if (valuePago.cardType === "credit") {
                    nombreTarjeta += ' - Crédito'
                  } else {
                    nombreTarjeta += ' - Débito'
                  }


                  return (
                    <Panel
                      extra={
                        <Tag color="blue">
                          Vigente
                        </Tag>
                      }
                      header={'Domicializacion - ' + moment(valuePago.createdAt).locale("es").format("ll")}
                      key={valuePago._id}
                    >
                      <Row>
                        <Col span={12}>
                          <p>
                            Creación:{" "}
                            {moment(valuePago.createdAt).locale("es").format("ll")}
                          </p>
                          <p>
                            Tarjeta:
                            {" " + nombreTarjeta + ' - **** ' + valuePago.terminacion}
                          </p>
                          <p>
                            Nombre:
                            {" " + valuePago.cardName}
                          </p>
                        </Col>
                        <Col span={12}>
                          <p>
                            Ultimo pago:{" "}
                            {valuePago.ultimaFechaCobro ? moment(valuePago.ultimaFechaCobro).locale("es").format("ll") : " - "}
                          </p>
                          {valuePago.estado === 1 && (
                            <ButtonItem type="primary" rojo onClick={() => this.cancelarDomicializacion(valuePago._id)}>
                              Cancelar Domicializacion
                            </ButtonItem>
                          )}
                        </Col>
                      </Row>
                    </Panel>
                  );

                } else {


                  let nombrePago = ''

                  if (valuePago.tipoPago) {

                    if (valuePago.tipoPago === 1) {

                      nombrePago = (valuePago.numTimbres + ' Timbres')

                    } else if (valuePago.tipoPago === 2) {

                      nombrePago = valuePago.texto

                    } else if (valuePago.tipoPago === 3) {

                      nombrePago = valuePago.texto

                    }

                  } else {

                    if (valuePago.timbres) {

                      nombrePago = (valuePago.numTimbres + ' Timbres')

                    } else {
                      nombrePago = 'Pago'
                    }

                  }

                  let extraPanel = null

                  if (valuePago.estado === 2) {
                    extraPanel = (
                      <Tag color="green">
                        Pagado
                      </Tag>
                    )
                  } else if (valuePago.estado === 0) {
                    extraPanel = (
                      <Tag color="orange">
                        En Proceso
                      </Tag>
                    )
                  } else if (valuePago.estado === 3) {
                    extraPanel = (
                      <Tag color="red">
                        Rechazado
                      </Tag>
                    )
                  }


                  return (
                    <Panel
                      extra={extraPanel}
                      header={nombrePago + ' - ' + moment(valuePago.createdAt).locale("es").format("ll") + ' - ' + dineroDisabledMask((valuePago.monto / 100))}
                      key={valuePago._id}
                    >
                      <Row>
                        <Col span={12}>
                          <p>
                            Creación Pago:{" "}
                            {moment(valuePago.createdAt).locale("es").format("ll")}
                          </p>
                          <p>
                            Vencimiento:{" "}
                            {moment(valuePago.conektaExpirationDate).locale("es").format("ll")}
                          </p>
                          {valuePago.estado === 0 && moment(valuePago.conektaExpirationDate) > moment() && (
                            <ButtonItem cyan type="primary" onClick={() => {
                              this.setState({
                                abrirPagoConekta: true,
                                pagoId: valuePago._id,
                                pagoConektaId: valuePago.conektaCheckoutId,
                              })
                            }}>
                              Ir al Pago
                            </ButtonItem>
                          )}
                        </Col>
                        <Col span={12}>
                          <p>
                            Dia de registro:{" "}
                            {moment(valuePago.updatedAt).locale("es").format("ll")}
                          </p>
                          <p>Monto: {dineroDisabledMask(valuePago.monto / 100)}</p>
                          {valuePago.estado === 0 && (
                            <ButtonItem type="primary" blanco onClick={() => this.checarPago(valuePago.conektaOrderId)}>
                              Checar Pago
                            </ButtonItem>
                          )}
                        </Col>
                      </Row>
                    </Panel>
                  );
                }
              })}
            </Collapse>
          );
          this.setState({ pagosHtml: html });
        } else {
          message.error('No se encontro informacion de la empresa')
        }

      })

    await axios.post('facturacion/datosEmpresa', { empresaId: this.props.id })
      .then(res => {
        if (res.data.success === 2) {
          this.setState({
            fechaVencimiento: res.data.empresa.fechaVencimiento,
            usuarios: res.data.empresa.usuarios,
            contadores: res.data.empresa.contadores,
            empresasActualizarTambien: res.data.empresasActualizarTambien,
            montoMensualFinalConIVA: res.data.montoMensualFinalConIVA,
            montoAnualFinalConIVA: res.data.montoAnualFinalConIVA,
            tipoPagoString: res.data.tipoPagoString,
            empresaActualizar: res.data.empresaActualizar,
          })
        } else {
          message.error('No se encontro informacion de la empresa')
          this.cerrarPagarEmpresa()
        };
      })

    this.setState({ loading: false });
  }


  // onFinish(tipoPago) {
  //   this.setState({ loading: true });
  //   axios.post('facturacion/pagarEmpresa', {
  //     empresaId: this.props.id,
  //     tipoPago: tipoPago,
  //     usuarioId: this.props.usuarioId
  //   }).then((res) => {
  //     this.setState({ loading: false });
  //     if (res.data.success === 2) {
  //         window.open(res.data.url, '_blank');
  //     } else {
  //         message.error("Sucedio un error y no se pudo generar la ficha de pago");
  //     }
  // });
  // }

  onFinish(tipoPago) {
    this.setState({ loading: true });
    axios.post('facturacion/generarPago', {
      empresaId: this.props.id,
      tipoPago: tipoPago,
      usuarioId: this.props.usuarioId
    }).then((res) => {
      this.setState({ loading: false });
      if (res.data.success === 2) {
        this.setState({
          loading: false,
          abrirPagoConekta: true,
          pagoId: res.data.pagoId,
          pagoConektaId: res.data.pagoConektaId,
        })
      } else if (res.data.success === 1) {
        message.warning(res.data.message ? res.data.message : "Sucedio un error y no se pudo generar la ficha de pago");
      } else {
        message.error("Sucedio un error y no se pudo generar la ficha de pago");
      }
    });
  }

  abrirDomicializacion() {

    axios.post('domicializacion/sePuedeDomiciliar', {
      empresaId: this.props.id,
    }).then((res) => {
      if (res.data.success === 2) {
        this.setState({
          abrirPagoConekta: true,
          abrirDomicializacion: true,
        })
      } else {
        message.warning(res.data.message ? res.data.message : "Sucedio un error y no se puede domiciliar");
      }
    });
  }

  faltaCorreo(funcion) {

    axios.post('empresas/faltaCorreo', {
      empresaId: this.props.id,
    }).then((res) => {
      if (res.data.success === 2) {
        if (res.data.correo) {
          funcion()
        } else {
          message.info("Debe agregar un correo a la empresa para poder pagar");
          this.setState({
            abrirCorreo: true,
          })
        }
      } else {
        message.warning(res.data.message ? res.data.message : "Sucedio un error");
      }
    });
  }

  render() {
    const fechaBase = moment(this.state.fechaVencimiento).subtract(5, "days");
    const planes = [
      {
        key: "domiciliar",
        titulo: "Domiciliar Pago",
        monto: this.state.montoMensualFinalConIVA,
        periodo: "/ mes",
        nota: `Se cobrará automáticamente cada mes a partir del ${fechaBase.format("DD [de] MMMM")}.`,
        boton: "Domiciliar Tarjeta",
        color: "olivaOscuro",
        onClick: () => this.faltaCorreo(() => this.abrirDomicializacion()),
      },
      {
        key: "mensual",
        titulo: "Mensual",
        monto: this.state.montoMensualFinalConIVA,
        periodo: "/ mes",
        nota: `Se agregará 1 mes a partir del ${fechaBase.format("DD [de] MMMM")}.`,
        boton: "Pagar 1 Mes",
        color: "petroleo",
        onClick: () => this.faltaCorreo(() => this.onFinish(2)),
      },
      {
        key: "anual",
        titulo: "Anual",
        monto: this.state.montoAnualFinalConIVA,
        periodo: "/ año",
        nota: `Se agregará 1 año a partir del ${fechaBase.format("DD [de] MMMM")}.`,
        boton: "Pagar 1 Año",
        color: "naranjaOscuro",
        onClick: () => this.faltaCorreo(() => this.onFinish(3)),
      },
    ];

    return (
      <>
        <ModalItem
          title="Facturación"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarPagarEmpresa.bind(this)}
          paddingTop
        >
          {this.state.abrirPagoConekta ?
            <>
              {this.state.abrirDomicializacion ?
                <DomicializacionConekta
                  visible={this.state.abrirPagoConekta && this.state.abrirDomicializacion}
                  cerrarDomicializacionConekta={() => {
                    this.consultarTodo()
                    this.setState({
                      abrirPagoConekta: false,
                      abrirDomicializacion: false,
                    })
                  }
                  }
                  empresaId={this.props.id}
                  fechaVencimiento={this.state.fechaVencimiento}
                />
                :
                <PagoConekta
                  visible={this.state.abrirPagoConekta && !this.state.abrirDomicializacion}
                  cerrarPagoConekta={() => {
                    this.consultarTodo()
                    this.setState({
                      abrirPagoConekta: false,
                      pagoId: null,
                      pagoConektaId: null,
                    })
                  }
                  }
                  pagoId={this.state.pagoId}
                  pagoConektaId={this.state.pagoConektaId}
                />
              }
            </>
            :
            (
              <>
                {this.state.fechaVencimiento && (() => {
                  const vencimiento = moment(this.state.fechaVencimiento);
                  const vencido = vencimiento < moment();
                  return (
                    <Alert
                      type={vencido ? "error" : "info"}
                      showIcon={false}
                      className={`pe-resumen-alert ${
                        vencido ? "" : "pe-resumen-alert--ok"
                      }`}
                      message={
                        <div className="pe-resumen">
                          <div
                            className={`pe-resumen-wallet ${
                              vencido
                                ? "pe-resumen-wallet--due"
                                : "pe-resumen-wallet--ok"
                            }`}
                          >
                            <WalletOutlined />
                          </div>
                          <div className="pe-resumen-stats">
                            <span className="pe-resumen-stat">
                              <UserOutlined className="pe-resumen-stat-icon" />
                              <b>{this.state.usuarios}</b> Usuarios
                            </span>
                            <span className="pe-resumen-stat">
                              <TeamOutlined className="pe-resumen-stat-icon" />
                              <b>{this.state.contadores}</b> Contadores
                            </span>
                          </div>
                          <Tag
                            color={vencido ? "red" : "green"}
                            className="pe-resumen-tag"
                          >
                            Vencimiento: {vencimiento.locale("es").format("LL")}
                          </Tag>
                        </div>
                      }
                    />
                  );
                })()}
                {this.state.empresaActualizar && <Alert
                  message="Empresa ligada a otro pago"
                  description={
                    <>
                      Esta empresa ya está ligada al pago de otra empresa. Si la paga, solamente se activará esta empresa.
                      <br />
                      Empresa a la cual está ligada:
                      {" "}
                      {this.state.empresaActualizar.persona
                        ? this.state.empresaActualizar.nombre
                        : this.state.empresaActualizar.nombre +
                        " " +
                        this.state.empresaActualizar.apellidoPaterno +
                        " " +
                        this.state.empresaActualizar.apellidoMaterno}
                    </>
                  }
                  type="warning"
                  showIcon
                  style={{ marginBottom: 10 }}
                />}
                {(this.state.empresasActualizarTambien && this.state.empresasActualizarTambien.length > 0) && <Alert
                  message="Empresas ligadas"
                  description={
                    <>
                      Esta empresa está ligada al pago de otras empresas. Si la paga, se activarán todas las empresas ligadas.
                      <br />
                      Empresas ligadas:
                      {" "}
                      {this.state.empresasActualizarTambien.map((empresa) => (
                        <>
                          <br /> &nbsp;&nbsp;&nbsp;&nbsp;
                          {empresa.persona
                            ? empresa.nombre
                            : empresa.nombre +
                            " " +
                            empresa.apellidoPaterno +
                            " " +
                            empresa.apellidoMaterno}
                        </>
                      ))}
                    </>
                  }
                  type="success"
                  showIcon
                  style={{ marginBottom: 10 }}
                />}
                {this.state.pagosHtml && (
                  <>
                    <div className="pe-section-title">Historial de pagos</div>
                    {this.state.pagosHtml}
                  </>
                )}
                <div className="pe-section-title" style={{ marginTop: 28 }}>Renueva tu suscripción</div>
                <Row
                  style={{ width: "100%", marginBottom: 28 }}
                  gutter={[16, 16]}
                >
                  {planes.map((plan) => (
                    <Col xs={24} md={8} key={plan.key}>
                      <div className="pe-plan">
                        <div className="pe-plan-head">
                          <div className="pe-plan-title">{plan.titulo}</div>
                        </div>
                        <div>
                          <span className="pe-plan-price">
                            {dineroDisabledMask(plan.monto)}
                          </span>
                          <span className="pe-plan-period"> {plan.periodo}</span>
                        </div>
                        <div className="pe-plan-nota">{plan.nota}</div>
                        <ul className="pe-plan-features">
                          <li>
                            <CheckCircleFilled className="pe-plan-check" /> Acceso a
                            toda la plataforma
                          </li>
                          <li>
                            <CheckCircleFilled className="pe-plan-check" /> Incluye{" "}
                            {this.state.tipoPagoString}
                          </li>
                          <li>
                            <CheckCircleFilled className="pe-plan-check" /> Facturación
                            Electrónica
                          </li>
                        </ul>
                        <p className="pe-plan-fineprint">
                          *Por el momento regalamos los timbres fiscales.
                          <br />
                          *Los timbres se pagan individualmente.
                        </p>
                        <div className="pe-plan-cta">
                          <ButtonItem
                            onClick={plan.onClick}
                            {...{ [plan.color]: true }}
                            size="large"
                            style={{ display: "block", width: "100%" }}
                          >
                            {plan.boton}
                          </ButtonItem>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </>
            )
          }
        </ModalItem>
        <CorreoEmpresa
          visible={this.state.abrirCorreo}
          cerrarCorreoEmpresa={() => {
            this.setState({ abrirCorreo: false });
            this.consultarTodo();
          }}
          empresaId={this.props.id}
          headersToken={this.props.headersToken}
        />
      </>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioId: state.user.usuarioId,
  };
};

export default connect(mapStateToProps)(PagarEmpresa);